import { forwardRef, memo } from 'react'
import classNames from 'classnames'

import css from './Html.module.scss'

import sanitizer from '@/utils/sanitizer'

export interface HtmlProps {
  className?: string
  html: string
}

export interface ViewProps extends HtmlProps {}

// View (pure and testable component, receives props from the controller)
export const View = forwardRef<HTMLDivElement, ViewProps>(({ className, html }, ref) => {
  return (
    <span
      className={classNames('Html', css.root, className)}
      ref={ref}
      dangerouslySetInnerHTML={{ __html: sanitizer(html) }}
    />
  )
})

View.displayName = 'Html-View'

// Controller (handles global state, router, data fetching, etc. Feeds props to the view component)
const Html = forwardRef<HTMLDivElement, HtmlProps>((props, ref) => {
  return <View {...props} ref={ref} />
})

Html.displayName = 'Html'

export default memo(Html)
